import {PaymentMethods} from "./payment_methods";

// shows the group's current monthyl bill info.
export class PaymentInfo extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    this.groupId = this.getAttribute('groupId')

    this.innerHTML = `
      <style>
      </style>

      <div class="light-colored-container">
        <h4>
          Payment Information
        </h4>
        <ul>
          <li>
            <a 
              href="#"
              id="update_payment_info"
            >
            Update payment method
            </a>
          </li>
        </ul>
      </div> 
    `
    this.init()
  }

  init() {
    this.querySelector('#update_payment_info').onclick = this.viewPaymentMethods.bind(this);
  }

  viewPaymentMethods() {
      const containerIdSelector = 'group_editor_billing_info_container'
      document.getElementById(containerIdSelector).style.display = 'none';
      let paymentHistory = new PaymentMethods(this.groupId, containerIdSelector);

      document.getElementById('simple_payment_history_container').innerHTML = '';
      document.getElementById('simple_payment_history_container').appendChild(paymentHistory);
  }
}
customElements.define('payment-info', PaymentInfo)